export class AlternativeProduct {
    OriginalId: number;
    Id_ProductAlternative: number;
    FullName: string;
    Id_ParentRecipe: number;
    W: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/alternative-product-model.ts